import { useCookies } from '@/hooks/use-cookies'
import { useMemo } from 'react'

import { AUTH_STORE_KEY, getAuthSliceFromCookieValue } from '@/store/slices/auth'

export const useAuthState = () => {
  const [cookies] = useCookies([AUTH_STORE_KEY])

  const authState = useMemo(() => getAuthSliceFromCookieValue(cookies?.[AUTH_STORE_KEY]), [cookies?.[AUTH_STORE_KEY]])

  return {
    isAuthenticated: !!authState?.accessToken,
    user: authState?.user,
  }
}
